import React from "react";
import { markCrashForNextBoot, resetAutoparkClientState } from "@/lib/clientRecovery";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    markCrashForNextBoot();
    if (typeof console !== "undefined") {
      console.error("[AutoPark]", error, info?.componentStack);
    }
  }

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      let msg = this.state.error?.message ? String(this.state.error.message).slice(0, 120) : "";
      if (/register_for_session|posthog/i.test(msg)) msg = "";
      return (
        <div className="dark min-h-screen bg-anthracite-900 flex flex-col items-center justify-center gap-4 px-6 text-center text-white">
          <p className="text-lg font-medium">Valami hiba történt az oldal betöltésekor.</p>
          <p className="text-slate-400 text-sm max-w-md">
            Próbáld újra, vagy frissítsd az oldalt. Ha Google belépés után látod, jelentkezz be email/jelszóval is.
          </p>
          {msg ? <p className="text-slate-500 text-xs font-mono max-w-md break-all">{msg}</p> : null}
          <div className="flex flex-wrap gap-3 justify-center">
            <button
              type="button"
              className="px-5 py-2.5 rounded-xl bg-amber-600 hover:bg-amber-500 text-white text-sm font-medium"
              onClick={() => {
                resetAutoparkClientState({ enableSafeMode: true });
                window.location.assign("/");
              }}
            >
              Helyi adatok törlése
            </button>
            <button
              type="button"
              className="px-5 py-2.5 rounded-xl bg-electric text-white text-sm font-medium"
              onClick={() => window.location.assign("/fiok")}
            >
              Fiók újra
            </button>
            <button
              type="button"
              className="px-5 py-2.5 rounded-xl glass border border-white/10 text-sm"
              onClick={() => window.location.assign("/")}
            >
              Főoldal
            </button>
          </div>
          <p className="text-slate-500 text-xs max-w-md mt-2">
            Ha minden frissítés után is ez jön: nyisd meg egyszer{" "}
            <button
              type="button"
              className="text-electric underline"
              onClick={() => {
                resetAutoparkClientState({ enableSafeMode: true });
                window.location.assign("/?autopark_reset=1");
              }}
            >
              autoparks.hu/?autopark_reset=1
            </button>
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
